import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM, { unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer } from 'react-dom'
//style
import './style.css';
// execute function if exist
const executeFunctionIfExist = (object, key) => {
  if (Object.prototype.hasOwnProperty.call(object, key)) {
    object[key]()
  }
}

// Render tootip content
class TooltipContent extends Component {

  state = {
    hover: false,
    transition: 'opacity',
    width: 0,
    height: 0
  }
  margin = 15
  defaultArrowStyle = {
    color: '#fff',
    borderColor: 'rgba(51,51,51,1)'
  }

 
  // lefe cycle hook
  componentDidMount() {
    this.updateSize()
  }

  // lief cylce hook
  componentWillReceiveProps() {
    this.setState({ transition: this.state.hover || this.props.active ? 'all' : 'opacity' }, () => {
      this.updateSize()
    })
  }

  // Update tooltip size
  updateSize() {
    let self = ReactDOM.findDOMNode(this)
    this.setState({
      width: self.offsetWidth,
      height: self.offsetHeight
    })
  }

  render() {

    return (
      <div className={this.props.position} style={{visibility: this.state.hover || this.props.active ? 'visible' : 'hidden',
      transition: `${this.state.transition} .3s ease-in-out, visibility .3s ease-in-out`,
      opacity: this.state.hover || this.props.active ? 1 : 0}}>
         <div class="text-content">
        {this.props.children}
      </div>
      <i></i>
      </div>
    )
  }
}

TooltipContent.defaultProps = {
  active: false,
  position: 'right',
  arrow: null,
  style: { style: {}, arrowStyle: {} }
}

const tooltipNode = {}

class Tooltip extends React.Component {

  // Lifecycle hook
  componentDidMount() {
    if (!this.props.active) {
      return
    }
    this.renderTooltip(this.props)
  }

  // Life cycle hook
  componentWillReceiveProps(nextProps) {
    if ((!tooltipNode[this.props.parent] && !nextProps.active) ||
      (!this.props.active && !nextProps.active)) {
      return
    }

    let props = Object.assign({}, nextProps)
    let newProps = Object.assign({}, nextProps)

    if (tooltipNode[this.props.parent] && tooltipNode[this.props.parent].timeout) {
      clearTimeout(tooltipNode[this.props.parent].timeout)
    }

    if (this.props.active && !props.active) {
      newProps.active = true
      tooltipNode[this.props.parent].timeout = setTimeout(() => {
        props.active = false
        this.renderTooltip(props)
      }, this.props.tooltipTimeout)
    }

    this.renderTooltip(newProps)
  }

  // Life cycle hook
  componentWillUnmount() {
    if (tooltipNode[this.props.parent]) {
      ReactDOM.unmountComponentAtNode(tooltipNode[this.props.parent].node)
      clearTimeout(tooltipNode[this.props.parent].timeout)
      delete tooltipNode[this.props.parent];
    }
  }

  // create tooltip content
  createTooltipContent() {
    tooltipNode[this.props.parent] = {
      node: document.createElement('div'),
      timeout: false
    }
    tooltipNode[this.props.parent].node.className = 'gdoc-tooltip'
    let parentElem=document.querySelector(`[data-tooltip=${this.props.parent}]`).parentNode;
    parentElem.appendChild(tooltipNode[this.props.parent].node)
  }

  // Render tooltip
  renderTooltip(props) {
    if (!tooltipNode[this.props.parent]) {
      this.createTooltipContent()
    }
    let { parent, ...other } = props

    let parentElem = typeof parent === 'string'
                      ? document.querySelector(`[data-tooltip=${parent}]`)
                      : parent

    // Render subtree
    renderSubtreeIntoContainer(
      this,
      <TooltipContent parentElement={parentElem} {...other} />,
      tooltipNode[this.props.parent].node
    )
  }

  // life cycle hook
  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}

Tooltip.propTypes = {
  parent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  active: PropTypes.bool,
  tooltipTimeout: PropTypes.number
}

Tooltip.defaultProps = {
  active: false,
  tooltipTimeout: 500
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/common/Tooltip/index.js